module.exports = __webpack_public_path__ + "img/per1.28ead458.png";